/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { Edit, Save, Trash2, X } from "react-feather";
import { toast } from "react-toastify";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { Card, CardBody } from "reactstrap";
import useFetcher from "../../../hooks/useFetcher";
import Breadcrumb from "../../../components/common/breadcrumb";
import {
  getLabCategories,
  createCategory,
  updateCategory,
  deleteCategory,
  createLevel,
  updateLevel,
  deleteLevel,
  getClientGroups,
  deleteClientGroup,
  getSectorGroups,
  deleteSectorGroup,
  getAssociatedGroups,
  deleteAssociatedGroup,
} from "../../../services/labServices";
import "./segmentation.scss";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { ButtonCrear, CategoryHeader, CategoryText, CategoryTitle } from "./styles";
import { handleErrors } from "../../../services/handleErrors";
import SectorGroupModal from "../../../components/course/segmentationSectorGroupModal";
import ClientGroupModal from "../../../components/course/segmentationClientGropuModal";
import AssociatedGroupModal from "../../../components/course/segmentationAsociadosGroupModal";
import { useAuth } from "../../../context/AuthContext";
import modulos from "../../../mocks/modulos";

const Segmentation = () => {
  const { currentUser } = useAuth();
  const isAudit = currentUser.haveAuditAccess(modulos.LAB);
  const [isLoadingC, setIsLoadingCategory] = useState(false);
  const [isLoadingN, setIsLoadingLevel] = useState(false);
  const [categories, isLoadingCategories, , , fetchCategories] = useFetcher(getLabCategories, undefined);
  const [clientGroups, isLoadingClientGroups, , , fetchClientGroups] = useFetcher(getClientGroups, undefined);
  const [sectorGroups, isLoadingSectorGroups, , , fetchSectorGroups] = useFetcher(getSectorGroups, undefined);
  const [associatedGroups, isLoadingAssociatedGroups, , , fetchAssociatedGroups] = useFetcher(getAssociatedGroups, undefined);
  const [isHovered, setIsHovered] = useState(null);
  const [isEditing, setIsEditing] = useState(null);
  const [editedCategory, setEditedCategory] = useState("");
  const [publico, setPublico] = useState([{ text: "asociados" }, { text: "clientes" }, { text: "candidato" }]);
  const inputRef = useRef(null);
  const [newInput, setNewInput] = useState(null);
  const [cat, setCat] = useState([]);
  const [levels, setLevels] = useState([]);
  const [sectorGroupModal, setSectorGroupModal] = useState(false);
  const [clientGroupModal, setClientGroupModal] = useState(false);
  const [clientGroupInfo, setClientGroupInfo] = useState(null);
  const [sectorGroupInfo, setSectorGroupInfo] = useState(null);
  const [associatedGroupModal, setAssociatedGroupModal] = useState(false);
  const [associatedGroupInfo, setAssociatedGroupInfo] = useState(null);

  useEffect(() => {
    if (categories && categories.categories) {
      setCat(categories.categories);
      setPublico(categories.audience);
      setLevels(categories.levels);
    }
  }, [categories]);

  useEffect(() => {
    // Enfocar el input cuando el componente se monte
    if (isEditing) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  useEffect(() => {
    setPublico(publico);
  }, [publico]);
  const handleInputChange = (event) => {
    setEditedCategory(event.target.value);
  };

  const handleSave = async (type) => {
    if (editedCategory === "") {
      toast.error("No puedes dejar el campo vacío");
      return;
    }
    if (type === "category") {
      setIsLoadingCategory(true);
      try {
        const { message } = await createCategory({ category: editedCategory });
        toast.success(message);
        fetchCategories();
      } catch (error) {
        handleErrors(error, toast.error);
      }

      setIsLoadingCategory(false);
    }

    if (type === "level") {
      setIsLoadingLevel(true);
      try {
        const { message } = await createLevel({ level: editedCategory });
        toast.success(message);
        fetchCategories();
      } catch (error) {
        handleErrors(error, toast.error);
      }

      setIsLoadingLevel(false);
    }

    // Limpiar el campo de entrada después de agregar
    setEditedCategory("");
    setNewInput(null);
    setIsEditing(null);
  };

  const handleKeyPressCreate = async (event, type) => {
    if (event.key === "Enter") {
      if (type === "category") {
        setIsLoadingCategory(true);
        try {
          const { message } = await createCategory({ category: editedCategory });
          toast.success(message);
          fetchCategories();
        } catch (error) {
          handleErrors(error, toast.error);
        }

        setIsLoadingCategory(false);
      }

      if (type === "level") {
        setIsLoadingLevel(true);
        try {
          const { message } = await createLevel({ level: editedCategory });
          toast.success(message);
          fetchCategories();
        } catch (error) {
          handleErrors(error, toast.error);
        }

        setIsLoadingLevel(false);
      }

      // Limpiar el campo de entrada después de agregar
      setEditedCategory("");
      setNewInput(null);
      setIsEditing(null);
    }
  };

  const handleKeyPressEdit = async (event, category, type) => {
    if (event.key === "Enter") {
      if (type === "category") {
        setIsLoadingCategory(true);

        try {
          const { message } = await updateCategory(category.id, { category: editedCategory });
          toast.success(message);
          fetchCategories();
        } catch (error) {
          handleErrors(error, toast.error);
        }

        setIsLoadingCategory(false);
      } else if (type === "level") {
        setIsLoadingLevel(true);

        try {
          const { message } = await updateLevel(category.id, { level: editedCategory });
          toast.success(message);
          fetchCategories();
        } catch (error) {
          handleErrors(error, toast.error);
        }

        setIsLoadingLevel(false);
      }

      // Limpiar el campo de entrada después de editar
      setEditedCategory("");
      setNewInput(null);
      setIsEditing(null);
    }
  };

  const handleDelete = async (id, type) => {
    if (type === "category") {
      setIsLoadingCategory(true);

      try {
        const { message } = await deleteCategory(id);
        toast.success(message);
        fetchCategories();
      } catch (error) {
        handleErrors(error, toast.error);
      }

      setIsLoadingCategory(false);
    }

    if (type === "level") {
      setIsLoadingLevel(true);

      try {
        const { message } = await deleteLevel(id);
        toast.success(message);
        fetchCategories();
      } catch (error) {
        handleErrors(error, toast.error);
      }

      setIsLoadingLevel(false);
    }

    if (type === "sectorGroup") {
      try {
        const { message } = await deleteSectorGroup(id);
        toast.success(message);
        fetchSectorGroups();
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }

    if (type === "clientGroup") {
      try {
        const { message } = await deleteClientGroup(id);
        toast.success(message);
        fetchClientGroups();
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }

    if (type === "associatedGroup") {
      try {
        const { message } = await deleteAssociatedGroup(id);
        toast.success(message);
        fetchAssociatedGroups();
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }
  };

  const reloadClientGroup = () => {
    fetchClientGroups();
  };

  const reloadSectorGroup = () => {
    fetchSectorGroups();
  };

  const reloadAssociatedGroup = () => {
    fetchAssociatedGroups();
  };

  return (
    <>
      <Helmet>
        <title>PIN - Back Office Lab</title>
      </Helmet>
      <Breadcrumb title="Segmentación" parent="Back Office lab" />

      <div className="container-fluid">
        <div className="row">
          <div className="col-4">
            <Card>
              <CategoryHeader className="py-3 px-4">
                <CategoryTitle>Público</CategoryTitle>
              </CategoryHeader>
              <BlurSpinner isLoading={isLoadingCategories}>
                <CardBody className="pb-3 segmentation-body custom-scrollbar">
                  <ListGroup>
                    {publico.map((category, index) => (
                      <ListGroupItem
                        className="p-1"
                        style={{
                          border: "none",
                          borderBottom: index === publico.length - 1 ? "none" : "1px solid lightgray",
                          borderRadius: "0px",
                          marginBottom: "5px",
                        }}
                      >
                        <CategoryText>{category.text}</CategoryText>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </CardBody>
              </BlurSpinner>
            </Card>
          </div>
          <div className="col-4">
            <Card>
              <CategoryHeader className="py-3 px-4">
                <CategoryTitle>Categorías</CategoryTitle>
                <div className="d-flex justify-content-center align-items-center pt-0 pb-0">
                  <ButtonCrear
                    size="xs"
                    type="button"
                    // className="btn btn-success px-2"
                    onClick={() => {
                      setNewInput("categoria");
                      setIsEditing("agregar");
                    }}
                    disabled={isAudit}
                  >
                    Crear
                  </ButtonCrear>
                </div>
              </CategoryHeader>
              <BlurSpinner isLoading={isLoadingCategories || isLoadingC}>
                <CardBody className="pb-3 segmentation-body custom-scrollbar">
                  <ListGroup>
                    {newInput === "categoria" && (
                      <ListGroupItem
                        className="p-1"
                        style={{ border: "none", borderBottom: "1px solid lightgray", borderRadius: "0px", marginBottom: "5px" }}
                        onMouseEnter={() => setIsHovered("agregar categoria")}
                        onMouseLeave={() => setIsHovered(null)}
                      >
                        {isEditing === "agregar" && (
                          <div className="d-flex justify-content-between">
                            <input
                              type="text"
                              placeholder="agregar"
                              value={editedCategory}
                              onChange={handleInputChange}
                              onKeyDown={(event) => handleKeyPressCreate(event, "category")}
                              ref={inputRef}
                              className="input-segmentation"
                            />
                            {isHovered === "agregar categoria" && (
                              <div className="flex justify-content-center">
                                <Save style={{ cursor: "pointer" }} size="18" onClick={() => handleSave("category")} />
                                <X
                                  style={{ cursor: "pointer" }}
                                  className="mx-1"
                                  size="18"
                                  onClick={() => {
                                    setNewInput(null);
                                    setIsEditing(null);
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </ListGroupItem>
                    )}
                    {cat.map((category, index) => (
                      <ListGroupItem
                        className="p-1"
                        style={{
                          border: "none",
                          borderBottom: index === cat.length - 1 ? "none" : "1px solid lightgray",
                          borderRadius: "0px",
                          marginBottom: "5px",
                        }}
                        onMouseEnter={() => setIsHovered(category.category)}
                        onMouseLeave={() => setIsHovered(null)}
                      >
                        <div className="d-flex justify-content-between">
                          {isEditing === category.category ? (
                            // eslint-disable-next-line no-return-assign

                            <input
                              type="text"
                              defaultValue={category.category}
                              onChange={handleInputChange}
                              onKeyDown={(event) => handleKeyPressEdit(event, { id: category.id, category: category.category }, "category")}
                              ref={inputRef}
                              className="input-segmentation"
                            />
                          ) : (
                            <CategoryText>{category.category}</CategoryText>
                          )}
                          {isHovered === category.category && !isAudit && (
                            <div className="actions-container">
                              <Edit
                                className="mr-2"
                                style={{ cursor: "pointer" }}
                                size="18"
                                color="black"
                                onClick={() => {
                                  isEditing === category.category ? setIsEditing(null) : setIsEditing(category.category);
                                  setNewInput(null);
                                }}
                              />
                              <Trash2 style={{ cursor: "pointer" }} size="18" color="black" onClick={() => handleDelete(category.id, "category")} />
                            </div>
                          )}
                        </div>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </CardBody>
              </BlurSpinner>
            </Card>
          </div>
          <div className="col-4">
            <Card>
              <CategoryHeader className="py-3 px-4">
                <CategoryTitle>Niveles</CategoryTitle>
                <div className="d-flex justify-content-center align-items-center pt-0 pb-0">
                  <ButtonCrear
                    size="xs"
                    type="button"
                    // className="btn btn-success px-2"
                    onClick={() => {
                      setNewInput("nivel");
                      setIsEditing("agregar");
                    }}
                    disabled={isAudit}
                  >
                    Crear
                  </ButtonCrear>
                </div>
              </CategoryHeader>
              <BlurSpinner isLoading={isLoadingCategories || isLoadingN}>
                <CardBody className="pb-3 segmentation-body custom-scrollbar">
                  <ListGroup>
                    {newInput === "nivel" && (
                      <ListGroupItem
                        className="p-1"
                        style={{ border: "none", borderBottom: "1px solid lightgray", borderRadius: "0px", marginBottom: "5px" }}
                        onMouseEnter={() => setIsHovered("agregar nivel")}
                        onMouseLeave={() => setIsHovered(null)}
                      >
                        {isEditing === "agregar" && (
                          <div className="d-flex justify-content-between">
                            <input
                              type="text"
                              placeholder="agregar"
                              value={editedCategory}
                              onChange={handleInputChange}
                              onKeyDown={(event) => handleKeyPressCreate(event, "level")}
                              ref={inputRef}
                              className="input-segmentation"
                            />
                            {isHovered === "agregar nivel" && (
                              <div className="flex justify-content-center">
                                <Save style={{ cursor: "pointer" }} size="18" onClick={() => handleSave("level")} />
                                <X
                                  style={{ cursor: "pointer" }}
                                  className="mx-1"
                                  size="18"
                                  onClick={() => {
                                    setNewInput(null);
                                    setIsEditing(null);
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </ListGroupItem>
                    )}
                    {levels.map((category, index) => (
                      <ListGroupItem
                        className="p-1"
                        style={{
                          border: "none",
                          borderBottom: index === levels.length - 1 ? "none" : "1px solid lightgray",
                          borderRadius: "0px",
                          marginBottom: "5px",
                        }}
                        onMouseEnter={() => setIsHovered(category.level)}
                        onMouseLeave={() => setIsHovered(null)}
                      >
                        <div className="d-flex justify-content-between">
                          {isEditing === category.level ? (
                            <input
                              type="text"
                              defaultValue={category.level}
                              onChange={handleInputChange}
                              onKeyDown={(event) => handleKeyPressEdit(event, { id: category.id, category: category.level }, "level")}
                              ref={inputRef}
                              className="input-segmentation"
                            />
                          ) : (
                            <CategoryText>{category.level}</CategoryText>
                          )}
                          {isHovered === category.level && !isAudit && (
                            <div className="actions-container">
                              <Edit
                                className="mr-2"
                                style={{ cursor: "pointer" }}
                                size="18"
                                color="black"
                                onClick={() => {
                                  isEditing === category.level ? setIsEditing(null) : setIsEditing(category.level);
                                  setNewInput(null);
                                }}
                              />
                              <Trash2 style={{ cursor: "pointer" }} size="18" color="black" onClick={() => handleDelete(category.id, "level")} />
                            </div>
                          )}
                        </div>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </CardBody>
              </BlurSpinner>
            </Card>
          </div>
          <div className="col-4">
            <SectorGroupModal toggle={() => setSectorGroupModal(!sectorGroupModal)} isOpen={sectorGroupModal} groupInfo={sectorGroupInfo} reload={reloadSectorGroup} />
            <Card>
              <CategoryHeader className="py-3 px-4">
                <CategoryTitle>Sector</CategoryTitle>
                <div className="d-flex justify-content-center align-items-center pt-0 pb-0">
                  <ButtonCrear
                    size="xs"
                    type="button"
                    // className="btn btn-success px-2"
                    onClick={() => {
                      setSectorGroupInfo(null);
                      setSectorGroupModal(!sectorGroupModal);
                    }}
                    disabled={isAudit}
                  >
                    Crear
                  </ButtonCrear>
                </div>
              </CategoryHeader>
              <BlurSpinner isLoading={isLoadingSectorGroups}>
                <CardBody className="pb-3 segmentation-body custom-scrollbar">
                  <ListGroup>
                    {sectorGroups.map((group, index) => (
                      <ListGroupItem
                        className="p-1"
                        style={{
                          border: "none",
                          borderBottom: index === sectorGroups.length - 1 ? "none" : "1px solid lightgray",
                          borderRadius: "0px",
                          marginBottom: "5px",
                        }}
                        onMouseEnter={() => setIsHovered(group.name)}
                        onMouseLeave={() => setIsHovered(null)}
                      >
                        <div className="d-flex justify-content-between">
                          <CategoryText>{group.name}</CategoryText>

                          {isHovered === group.name && !isAudit && (
                            <div className="actions-container">
                              <Edit
                                className="mr-2"
                                style={{ cursor: "pointer" }}
                                size="18"
                                color="black"
                                onClick={() => {
                                  setSectorGroupInfo(group);
                                  setSectorGroupModal(!sectorGroupModal);
                                }}
                              />
                              <Trash2 style={{ cursor: "pointer" }} size="18" color="black" onClick={() => handleDelete(group.id, "sectorGroup")} />
                            </div>
                          )}
                        </div>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </CardBody>
              </BlurSpinner>
            </Card>
          </div>
          <div className="col-4">
            <ClientGroupModal toggle={() => setClientGroupModal(!clientGroupModal)} isOpen={clientGroupModal} groupInfo={clientGroupInfo} reload={reloadClientGroup} />
            <Card>
              <CategoryHeader className="py-3 px-4">
                <CategoryTitle>Cliente</CategoryTitle>
                <div className="d-flex justify-content-center align-items-center pt-0 pb-0">
                  <ButtonCrear
                    size="xs"
                    type="button"
                    // className="btn btn-success px-2"
                    onClick={() => {
                      setClientGroupInfo(null);
                      setClientGroupModal(!clientGroupModal);
                    }}
                    disabled={isAudit}
                  >
                    Crear
                  </ButtonCrear>
                </div>
              </CategoryHeader>
              <BlurSpinner isLoading={isLoadingClientGroups || isLoadingN}>
                <CardBody className="pb-3 segmentation-body custom-scrollbar">
                  <ListGroup>
                    {clientGroups.map((group, index) => (
                      <ListGroupItem
                        className="p-1"
                        style={{
                          border: "none",
                          borderBottom: index === clientGroups.length - 1 ? "none" : "1px solid lightgray",
                          borderRadius: "0px",
                          marginBottom: "5px",
                        }}
                        onMouseEnter={() => setIsHovered(group.name)}
                        onMouseLeave={() => setIsHovered(null)}
                      >
                        <div className="d-flex justify-content-between">
                          <CategoryText>{group.name}</CategoryText>

                          {isHovered === group.name && !isAudit && (
                            <div className="actions-container">
                              <Edit
                                className="mr-2"
                                style={{ cursor: "pointer" }}
                                size="18"
                                color="black"
                                onClick={() => {
                                  setClientGroupModal(!clientGroupModal);
                                  setClientGroupInfo(group);
                                }}
                              />
                              <Trash2 style={{ cursor: "pointer" }} size="18" color="black" onClick={() => handleDelete(group.id, "clientGroup")} />
                            </div>
                          )}
                        </div>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </CardBody>
              </BlurSpinner>
            </Card>
          </div>
          <div className="col-4">
            <AssociatedGroupModal
              toggle={() => setAssociatedGroupModal(!associatedGroupModal)}
              isOpen={associatedGroupModal}
              groupInfo={associatedGroupInfo}
              reload={reloadAssociatedGroup}
            />
            <Card>
              <CategoryHeader className="py-3 px-4">
                <CategoryTitle>Asociados</CategoryTitle>
                <div className="d-flex justify-content-center align-items-center pt-0 pb-0">
                  <ButtonCrear
                    size="xs"
                    type="button"
                    onClick={() => {
                      setAssociatedGroupInfo(null);
                      setAssociatedGroupModal(!associatedGroupModal);
                    }}
                    disabled={isAudit}
                  >
                    Crear
                  </ButtonCrear>
                </div>
              </CategoryHeader>
              <BlurSpinner isLoading={isLoadingAssociatedGroups || isLoadingN}>
                <CardBody className="pb-3 segmentation-body custom-scrollbar">
                  <ListGroup>
                    {associatedGroups.map((group, index) => (
                      <ListGroupItem
                        className="p-1"
                        style={{
                          border: "none",
                          borderBottom: index === associatedGroups.length - 1 ? "none" : "1px solid lightgray",
                          borderRadius: "0px",
                          marginBottom: "5px",
                        }}
                        onMouseEnter={() => setIsHovered(group.name)}
                        onMouseLeave={() => setIsHovered(null)}
                      >
                        <div className="d-flex justify-content-between">
                          <CategoryText>{group.name}</CategoryText>

                          {isHovered === group.name && !isAudit && (
                            <div className="actions-container">
                              <Edit
                                className="mr-2"
                                style={{ cursor: "pointer" }}
                                size="18"
                                color="black"
                                onClick={() => {
                                  setAssociatedGroupModal(!associatedGroupModal);
                                  setAssociatedGroupInfo(group);
                                }}
                              />
                              <Trash2 style={{ cursor: "pointer" }} size="18" color="black" onClick={() => handleDelete(group.id, "associatedGroup")} />
                            </div>
                          )}
                        </div>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </CardBody>
              </BlurSpinner>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Segmentation);
